import React from 'react';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { SecondaryBody } from '@grnhse/seedling/lib/birch/typography';

const LocationCell = ({ location }: { location?: string | null }) => {
  if (!location) {
    return null;
  }

  return (
    <Stack
      sx={{
        padding: 1,
        paddingLeft: 0,
        height: '100%',
      }}
    >
      <SecondaryBody className="pii-blur">{location}</SecondaryBody>
    </Stack>
  );
};

export default LocationCell;
